export default __webpack_public_path__ + "static/media/roomLeave.105d3f50.wav";